import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginComponent } from './pages/login/login.component';
import { MaterialModule } from './services/material.module';
import { ToastrModule } from 'ngx-toastr';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';
import { LayoutComponent } from './pages/layout/layout.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { Interceptor } from './services/interceptor';
import { SharedModule } from './services/shared.module';
import { ConformationDialogComponent } from './services/conformation-dialog/conformation-dialog.component';
import { SyncfusionModule } from './services/syncfusion.module';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { AngularImageViewerModule } from '@hreimer/angular-image-viewer';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { ClientDetailsComponent } from './pages/common-pop-up/client-details/client-details.component';
import { PatientDetailsComponent } from './pages/common-pop-up/patient-details/patient-details.component';
import { PhysicianDetailsComponent } from './pages/common-pop-up/physician-details/physician-details.component';
import { CaseInfoPopUpComponent } from './pages/common-pop-up/case-info-pop-up/case-info-pop-up.component';
import { ViewPatientHistoryComponent } from './pages/common-pop-up/view-patient-history/view-patient-history.component';
import './services/string.extensions';
import { HeaderPagesModule } from './pages/header-pages/header-pages.module';
import { ImageViewerComponent } from './pages/common-pop-up/image-viewer/image-viewer.component';
import { PatientLogDialogComponent } from './pages/common-pop-up/patient-log/patient-log.component';
import { ViewLogsComponent } from './pages/common-pop-up/view-logs/view-logs.component';
import { NgxMaskModule } from 'ngx-mask';
import { NgxSmoothDnDModule } from 'ngx-smooth-dnd';
import { AuthGuard } from './auth-guard.service';
import { ConfigService } from './services/config.service';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LayoutComponent,
    DashboardComponent,
    ConformationDialogComponent,
    PatientLogDialogComponent,
    ImageViewerComponent,
    ClientDetailsComponent,
    PatientDetailsComponent,
    PhysicianDetailsComponent,
    CaseInfoPopUpComponent,
    ViewPatientHistoryComponent,
    ViewLogsComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    ToastrModule.forRoot({
      preventDuplicates: true,
      countDuplicates: true,
    }),
    AngularSvgIconModule.forRoot(),
    NgxSpinnerModule,
    SyncfusionModule,
    AngularImageViewerModule,
    NgxExtendedPdfViewerModule,
    NgxMaskModule.forRoot(),
    SharedModule,
    HeaderPagesModule,
    NgxSmoothDnDModule,
  ],
  entryComponents: [
    ConformationDialogComponent,
    PatientLogDialogComponent,
    ImageViewerComponent,
    ClientDetailsComponent,
    PatientDetailsComponent,
    PhysicianDetailsComponent,
    CaseInfoPopUpComponent,
    ViewPatientHistoryComponent,
    ViewLogsComponent,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true }, AuthGuard,
    {
      provide: APP_INITIALIZER,
      useFactory: (configService: ConfigService) => () => configService.loadConfigurations().toPromise(),
      deps: [ConfigService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
